module.exports = [["KEEP","action:mmAppIdentified,mmUserLogged,mmUserStatus"]]